import React, {ReactNode} from "react";
import {AnnotationProperties, SVG_NAMESPACE} from "../Annotation";
import FunctionHelper from "../../helper/FunctionHelper";
import PortalPureComponent from "../../components/PortalPureComponent";

export class NewParagraphIcon extends PortalPureComponent<AnnotationProperties> {
	/**
	 * render component as react node
	 */
	public render(): ReactNode {
		return (
			<svg xmlns={SVG_NAMESPACE} width={this.props.width} height={this.props.height} viewBox="0 0 64 64"
				 style={{
					 opacity: FunctionHelper.applyValue(this.props.opacity, 1),
					 transform: "rotate(" + FunctionHelper.applyValue(this.props.rotation, 0) + "deg)",
				 }}>
				<path d="M 32.003143,10.913072 57.432701,53.086929 6.567299,53.083723 z" id="path2985"
					  style={{
						  fill: this.props.color,
						  fillOpacity: 0.5,
						  fillRule: "nonzero",
						  stroke: "#000000",
						  strokeWidth: 1,
						  strokeMiterlimit: 4,
						  strokeOpacity: 1,
						  strokeDasharray: "none"
					  }}/>
			</svg>
		);
	}
}